import { fetchPropertyDefinitions } from '../../form/api';
export class PropertyDefinitionsCache {
  constructor() {
    this.cache = {};
  }

  get({
    objectTypeId,
    httpClient
  }) {
    const cachedPromise = this.cache[objectTypeId];

    if (cachedPromise) {
      return cachedPromise;
    }

    const promise = fetchPropertyDefinitions(objectTypeId, httpClient);
    this.cache[objectTypeId] = promise;
    return promise;
  }

  clear() {
    this.cache = {};
  }

}